/**
 * Grand Quack Auto — environmental easter egg signs.
 *
 * Funny billboards and signs placed around the city.
 * Canvas-rendered textures — no file downloads.
 * Per virality.md: "Plant meme-friendly surprises around the city."
 */

import * as THREE from 'three';
import type { World } from '../types';

const SIGNS = [
  { text: '🦆 DUCK CROSSING', color: '#ffdd00', bg: '#333', x: -24, z: 8, rot: 0 },
  { text: 'EGGCELLENT\nAUTO PARTS', color: '#ff6600', bg: '#1a1a2e', x: 8, z: -24, rot: Math.PI / 2 },
  { text: 'QUACK FM 97.5\nAll Honks All The Time', color: '#44ff44', bg: '#0a2a0a', x: 24, z: 24, rot: Math.PI },
  { text: 'WANTED\n🦆 RUBBER DUCK\nArmed & Dangerous', color: '#ff4444', bg: '#2a1a0a', x: -8, z: 40, rot: -Math.PI / 2 },
  { text: 'DUCK LIVES\nMATTER', color: '#ffd700', bg: '#1a1a1a', x: 32, z: -16, rot: 0 },
  { text: 'NO QUACKING\nZONE\n(just kidding)', color: '#ffffff', bg: '#cc2222', x: -32, z: -32, rot: Math.PI / 4 },
];

export function generateSigns(world: World): void {
  for (const sign of SIGNS) {
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 192;
    const ctx = canvas.getContext('2d')!;

    // Background.
    ctx.fillStyle = sign.bg;
    ctx.fillRect(0, 0, 256, 192);

    // Border.
    ctx.strokeStyle = sign.color;
    ctx.lineWidth = 4;
    ctx.strokeRect(4, 4, 248, 184);

    // Text.
    ctx.fillStyle = sign.color;
    ctx.textAlign = 'center';
    const lines = sign.text.split('\n');
    const fontSize = lines.length > 2 ? 22 : 28;
    ctx.font = `bold ${fontSize}px Arial`;
    const lineHeight = fontSize + 8;
    const startY = 96 - ((lines.length - 1) * lineHeight) / 2;
    for (let i = 0; i < lines.length; i++) {
      ctx.fillText(lines[i]!, 128, startY + i * lineHeight);
    }

    // Create billboard mesh.
    const texture = new THREE.CanvasTexture(canvas);
    const mesh = new THREE.Mesh(
      new THREE.PlaneGeometry(4, 3),
      new THREE.MeshBasicMaterial({ map: texture, side: THREE.DoubleSide }),
    );
    mesh.position.set(sign.x, 5, sign.z);
    mesh.rotation.y = sign.rot;
    world.scene.add(mesh);
  }
}
